import React, { useEffect, FC } from "react";
import { selectOverlaps } from "@sdge-store/overlaps/overlaps.selector";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  addOverlapsQuickView,
  deleteQuickView,
  fetchOverlapsData,
  fetchOverlapsQuickViews,
  updateOverlapsQuickView,
} from "@sdge-store/overlaps/overlaps.async";
import { QuickViews, AddViewMenu } from "./components";
import {
  handleColumnChoosen,
  handleInputText,
  handlePrivacy,
  handleQuickViewId,
  handleQuickViewsModal,
  handleQuickViewsParams,
  handleSearch,
  handleSelectedRows,
} from "@sdge-store/overlaps/overlaps.slice";

import { generateSortingString } from "@sdge-utils/helpers/sortHelpers/sortHelpers";
import { Constants } from "@sdge-store/overlaps/overllaps.constants";
import {
  assignFrozenColumns,
  assignHiddenCols,
  assignSelect,
} from "@sdge-utils/helpers/quickViewsHelpers/quickViewsHelpers";
import { ColumnApi } from "ag-grid-community";
import { generateAddQuickView } from "@sdge-utils/helpers/filterHelpers/filterHelpers";

const OverlapsQuickViewsOptions: FC<{ columnApi: ColumnApi }> = ({
  columnApi,
}) => {
  const {
    columnOrder,
    filteringRules,
    hiddenColumns,
    sort,
    quickViews,
    isQuickVeiwsModalOpen,
    frozenColumns,
    initialColumnDefs,
    initialColumnsOrder,
    currentFilter,
    selectedQuickVewName,
    selectedQuickViewPrivacy,
    selectedQuickViewId,
  } = useAppSelector(selectOverlaps);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (quickViews.length === 0) {
      dispatch(fetchOverlapsQuickViews());
    }
  }, [dispatch, quickViews.length]);

  const AddMenuViewsWithProps = () => (
    <AddViewMenu
      quickViews={quickViews}
      columnsOrder={columnOrder}
      filters={filteringRules}
      hiddenColumns={hiddenColumns}
      frozenColumns={frozenColumns}
      orders={sort}
      setClose={handleQuickViewsModal}
      addColumnAction={addOverlapsQuickView}
    />
  );
  const fetchView = (
    sort: any[],
    filter: any[],
    id: string,
    quickViews: any[],
    columnDefs: any[],
    hiddenColumns: string[],
    frozenColumns: string[],
    columnsOrder: string[],
    selectedName: string
  ) => {
    dispatch(handleSelectedRows([]));
    dispatch(handleColumnChoosen(assignSelect(quickViews, id)));
    const sortingRules = generateSortingString(sort);
    dispatch(fetchOverlapsData([0, sortingRules, filter, true]));
    const hiddenColsFilter = assignHiddenCols(columnDefs, hiddenColumns);
    const pinnedColsFilter = assignFrozenColumns(
      hiddenColsFilter,
      frozenColumns
    );

    const firstTwoElements = pinnedColsFilter.slice(0, 2);
    const newColumnsInfo = pinnedColsFilter.slice(2).sort((a, b) => {
      return columnsOrder.indexOf(a.field) - columnsOrder.indexOf(b.field);
    });
    const newColumnOrder = newColumnsInfo.map((item) => item.field);

    const newColumns = [...firstTwoElements, ...newColumnsInfo];
    const newColumnParams = {
      columnDefs: newColumns,
      hiddenColumns: hiddenColumns,
      frozenColumns: frozenColumns,
      columnOrder: columnsOrder,
      sort: sort,
      filter: filter,
      filteringRules: filter,
      selectedName: selectedName,
    };
    dispatch(handleQuickViewsParams(newColumnParams));
    dispatch(handleSearch(""));
    dispatch(handleInputText(""));
    columnApi.moveColumns(newColumnOrder, 2);
  };

  const resetViews = (quickViews: any[]) => {
    dispatch(handleSelectedRows([]));
    const newQuickVews = quickViews.map((item) => {
      return { ...item, selected: false };
    });
    const resetedParams = {
      columnDefs: initialColumnDefs,
      hiddenColumns: [],
      frozenColumns: [],
      columnOrder: initialColumnsOrder,
      sort: [],
      filter: [],
      filteringRules: [],
      selectedName: "",
    };
    dispatch(handleColumnChoosen(newQuickVews));
    dispatch(fetchOverlapsData([0, "", [], true]));
    dispatch(handleQuickViewsParams(resetedParams));
    dispatch(handleSearch(""));
    dispatch(handleInputText(""));

    columnApi.moveColumns(initialColumnsOrder, 2);
  };

  const handleUpdate = (selectedname: string) => {
    dispatch(
      updateOverlapsQuickView(
        generateAddQuickView(
          columnOrder,
          currentFilter,
          hiddenColumns,
          frozenColumns,
          selectedname,
          sort,
          selectedQuickViewPrivacy,
          selectedQuickViewId
        )
      )
    );
  };

  const handleChange = (e: any) => {
    dispatch(handlePrivacy(e.target.checked));
  };

  const handleSetPrivacy = (privacy: boolean) => {
    dispatch(handlePrivacy(privacy));
  };

  const handleSetId = (id: string) => {
    dispatch(handleQuickViewId(id));
  };

  return (
    <QuickViews
      selectedName={selectedQuickVewName}
      resetViews={resetViews}
      component={AddMenuViewsWithProps}
      setOpen={handleQuickViewsModal}
      open={isQuickVeiwsModalOpen}
      quickViews={quickViews}
      columnDefs={Constants.columnDefs}
      fetchView={fetchView}
      deleteView={deleteQuickView}
      updateView={handleUpdate}
      handleChange={handleChange}
      handleSetPrivacy={handleSetPrivacy}
      handleSetId={handleSetId}
    />
  );
};

export default OverlapsQuickViewsOptions;
